export const REACT_STORE_TYPE: symbol = Symbol.for('react.store')

export type ReactStore<Value, Action = Value | ((prev: Value) => Value)> = {
  [REACT_STORE_TYPE]: never
  update: (action: Action) => void
  getState: () => Value
  select: Value extends Map<infer K, infer V>
    ? (key: K) => ReactStore<V, V | ((prev: V) => V)>
    : Value extends object
      ? <K extends keyof Value>(
          key: K,
        ) => ReactStore<Value[K], Value[K] | ((prev: Value[K]) => Value[K])>
      : undefined
}

/**
 * Represents a data source which can be connected to React by wrapping it as a
 * React Store
 */
export interface ISource<S, A> {
  /**
   * Returns an immutable snapshot of the current state
   */
  getState(): S
  /**
   * A pure function which takes and arbitrary state and an updater/action and
   * returns a new state.
   *
   * React needs this in order to generate temporary states.
   *
   * See: https://jordaneldredge.com/notes/react-rebasing/
   */
  reducer: Reducer<S, A>
}

export type Reducer<S, A> = (state: S, action: A) => S
